import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../../../services/general/general.service';
import { DateRange } from '../../../../interfaces/date-range.interface';
import { EventApi } from '@fullcalendar/common';
import { HoursPackDialogComponent } from 'src/app/components/hours-pack/hours-pack-dialog.component';
import { BookingDialogComponent } from 'src/app/components/booking-dialog/booking-dialog.component';
import { Capacitor } from '@capacitor/core';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DateTime } from 'luxon';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  public teacher: any = {};
  public timezone: any;
  public loading = true;
  public loading2 = false;
  public teacherId: Number | undefined;
  public schedule: any = new Array();
  public lessonOptions: any = [];
  public headerHeight: Number = 0;
  public hoursLeft: Number = 0;
  public form: FormGroup;
  public currentSubject: any = null;
  public lesson_id: any;

  public user: any;
  public userInfo: any;

  public isStudent: Boolean = false;
  public canFreeBook: Boolean = false;

  public currency: any;
  public selectedOption:any;
  public opt: any;

  public ios: boolean | undefined;


  constructor(
    private route: ActivatedRoute,
    private general: GeneralService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder
  ) {

    if(!localStorage.getItem("currency")){
      localStorage.setItem('currency', "eur");
    }

    this.currency = localStorage.getItem('currency');

    window.addEventListener('currency_change', () => {
      this.currency = localStorage.getItem('currency');
    }, false);
    
    
    this.form = this.formBuilder.group(
      {
        lesson: [null],
        level: [null],
      },
      { validators: this.validateLessonForm() }
    );

    if (Capacitor.getPlatform() === 'ios') {
      this.ios = true;
    }else{
      this.ios = false;
    }
  }

  openWordiix(){
    window.open("https://app.wordiix.com/", '_self');
  }

  async ngOnInit() {

    await this.getUserInfo();
    
    if (this.user) {
      this.isStudent = this.user.rol === 'student';
    }

    try {
      
      this.loading = true;
      const id = this.route.snapshot.paramMap.get('id');
      this.lesson_id = this.route.snapshot.paramMap.get('lesson_id');

      if (id && this.lesson_id) {
        this.teacherId = Number.parseInt(id);
        this.lesson_id = Number.parseInt(this.lesson_id);
        await this.getTeacher();
      }

      this.scrollToTop();

    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  ngAfterViewInit() {
    // Declare Header Height
    const headerHeight = this.general.getHeaderHeight('header-container');
    if (headerHeight) {
      this.headerHeight = headerHeight;
    }

    const successPayment = this.route.snapshot.queryParamMap.get('buy_success');

      if (successPayment === 'true') {
         this.general.showSuccess('success-payment');
      } else if (successPayment === 'false') {
         this.general.showDanger('error-payment');
      }

  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  get levelOptions() {
    let res: any = [];
    return res;
  }

  /**
   * Get data from current teacher
   */
  async getTeacher() {

    try  {

      let teacher;

      if (!this.user) {

        const response = await this.general.httpGet(`teacher/${this.teacherId}/${this.lesson_id}`);
        teacher = response.data;

        this.currentSubject = {
          id: response.data.lesson_id,
          name: response.data.lesson_name,
        };
        
      } else {

        const requests = [
          this.general.httpGet(`teacher/${this.teacherId}/${this.lesson_id}`),
          this.general.httpGet(`booking-available-hours/${this.teacherId}/${this.lesson_id}`),
        ];
        const response: any = await this.general.forkJoin(requests);
        teacher = response[0].data;

        this.currentSubject = {
          id: response[0].data.lesson_id,
          name: response[0].data.lesson_name,
        };

        if (response[1].message.data.can_free_book) {
          this.hoursLeft = 1;
          this.canFreeBook = true;
        } else {
          this.hoursLeft = response[1].message.data.total_pending;
          this.canFreeBook = false;
        }

      }

      this.teacher = teacher;

      this.teacher.custom_lessons_modified = this.general.getArrayUniqueValues(
        this.teacher.custom_lessons,
        ['name', 'lesson_id']
      );

      this.teacher.lessons = this.teacher.lessons.map((e: any) => {
        e.type = e?.levels[0]?.type;
        return e;
      });

    }

    catch(e) {
      this.general.navigate('/search/teacher');
    }

  }

  /**
   * Get shedule from api
   * @param dateRange
   * @returns
   */
  async getSchedule(dateRange: DateRange) {
    this.timezone = dateRange.timezone;
    let request = await this.general.httpGet(
      `booking-schedule/${this.teacherId}`,
      {
        start_date: dateRange.start,
        end_date: dateRange.end,
        timezone: this.timezone,
      }
    );

    let schedule = request.data.map((element: any) => {
      return {
        ...element,
        groupId: this.general.getRandomId(10),
        selected: false,
      };
    });

    return this.concatenateConsecutiveEvents(schedule);
  }

  /**
   * Scroll to top of the page
   */
  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  /**
   * Lister to be triggered when the full calendar's view change
   * @param event
   */
  async onChangeView(event: DateRange) {
    const schedule: any = await this.getSchedule(event);
    this.schedule = [].concat(schedule);
  }

  /**
   * Show Payment Dialog to select how many hours the user wants to buy
   */
  showPaymentDialog() {
    const data = {
      priceHour: this.teacher.price_hour_single,
      teacher_id: this.teacherId,
      teacher_info: this.teacher,
      lesson_id:this.lesson_id
    };
    
    

    const dialogRef = this.dialog.open(HoursPackDialogComponent, {
      data,
      autoFocus: false,
      disableClose: true,
    });

    const subscribed = dialogRef.afterClosed().subscribe(async (data) => {
      try {
        subscribed.unsubscribe();

        if (!data) {
          return;
        }
        this.loading2 = true;

        const body = {
          type: 'single',
          teacher_id: this.teacherId,
          quantity: data.hours,
          payment_method: data.paymentMethod,
          coupon_text: data.coupon_text,
          lesson_id: data.lesson_id
        };

        const response = await this.general.httpPost('booking-buy', body);

        window.location.href = response.data.data;
      } catch (e: any) {
        this.loading2 = false;
      } finally {
        this.loading2 = false;
      }
    });
  }

  /**
   * Chekc if booking button is disabled
   */
  get isDisabled() {
    const selecteds = this.schedule.filter((e: any) => {
      return e.selected;
    });
    if (
      selecteds.length > 0 &&
      selecteds.length <= this.hoursLeft &&
      this.form.valid
    )
      return false;
    return true;
  }

  /**
   * Used for create bookings based on remaining hours
   */
  async createBookings() {
    try {
      
      this.loading2 = true;
      // let lesson_id = this.form.value.lesson.id;
      let lesson_id = this.lesson_id;
      let custom_lesson = 0;
      // if (
      //   typeof lesson_id === 'string' &&
      //   lesson_id.includes('custom_lesson_')
      //   ) {
      //     const custom_lesson_finded = this.teacher.custom_lessons.find(
      //       (e: any) => {
      //         return (
      //           e.name === this.form.value.lesson.name &&
      //           (this.form.value.level
      //             ? e.level_id === this.form.value.level.id
      //             : true)
      //         );
      //       }
      //     );
      //     lesson_id = custom_lesson_finded.id;
      //     custom_lesson = 1;
      //   }

      //let level = this.form.value.level ? this.form.value.level.id : null;

      const selecteds = this.schedule.filter((e: any) => {
        return e.selected;
      });

      const array: any = [];
      selecteds.forEach((e: any) => {
        array.push({
          custom_lesson: custom_lesson,
          study_lesson_id: lesson_id,
          study_lesson_level_id: null,
          booking_start_datetime: e.start,
          booking_end_datetime: e.end,
        });
      });

      await this.general.httpPost('booking-assign', {
        teacher_id: this.teacherId,
        bookings_dates: array,
      });

      await this.general.showSuccess('booking-created');

      if (!this.user) {
        this.general.navigate('auth/login');
      }

      if (this.user.rol == 'teacher') {
        this.general.navigate('/teacher/calendar');
      } else {
        this.general.navigate('/student/settings/calendar');
      }

    } catch (error) {

    } finally {

      this.loading2 = false;

      if (!this.user) {
        this.general.navigate('auth/login');
      }

      /////////
      await this.getTeacher();
      ////////
    }
  }

  /**
   * Used for create free bookings based on remaining hours
   */
  async createFreeBookings() {
    try {
      this.loading2 = true;
      // let lesson_id = this.form.value.lesson.id;
      let lesson_id = this.lesson_id;
      let custom_lesson = 0;
      // if (
      //   typeof lesson_id === 'string' &&
      //   lesson_id.includes('custom_lesson_')
      // ) {
      //   const custom_lesson_finded = this.teacher.custom_lessons.find(
      //     (e: any) => {
      //       return (
      //         e.name === this.form.value.lesson.name &&
      //         (this.form.value.level
      //           ? e.level_id === this.form.value.level.id
      //           : true)
      //       );
      //     }
      //   );
      //   lesson_id = custom_lesson_finded.id;
      //   custom_lesson = 1;
      // }

      // let level = this.form.value.level ? this.form.value.level.id : null;

      const selecteds = this.schedule.filter((e: any) => {
        return e.selected;
      });

      const array: any = [];
      selecteds.forEach((e: any) => {
        array.push({
          custom_lesson: custom_lesson,
          study_lesson_id: lesson_id,
          study_lesson_level_id: null,
          booking_start_datetime: e.start,
          booking_end_datetime: e.end,
        });
      });
      const selected = array[0];

      await this.general.httpPost('booking-assign-free', {
        teacher_id: this.teacherId,
        custom_lesson: selected.custom_lesson,
        study_lesson_id: selected.study_lesson_id,
        study_lesson_level_id: selected.study_lesson_level_id,
        booking_start_datetime: selected.booking_start_datetime,
        booking_end_datetime: selected.booking_end_datetime,
      });

      await this.general.showSuccess('booking-created');
   
      if (!this.user) {
        this.general.navigate('auth/login');
      }

      if (this.user.rol == 'teacher') {
        this.general.navigate('/teacher/calendar');
      } else {
        this.general.navigate('/student/settings/calendar');
      }

    } catch (error) {

    } finally {

      this.loading2 = false;

      if (!this.user) {
        this.general.navigate('auth/login');
      }
    }
  }

  /**
   * Event listener to tigger on event is clicked
   * @param event
   */
  async onEventClicked(event: any) {
    try {
      const index = this.schedule.findIndex((e: any) => {
        let start = DateTime.fromISO(event.startStr).setZone('UTC').toISO();
        let eventStart = DateTime.fromISO(e.start).setZone('UTC').toISO();
        return eventStart === start;
      });
      this.checkEvent(index);
    } catch (error: any) {
    }
  }

  /**
   * If event clicked is already selected, init process of concatenated
   * Else mark it as selected or show Booking dialog
   * @param index
   * @returns
   */
  checkEvent(index: any) {
    const selecteds = this.schedule.filter((e: any) => {
      return e.selected;
    });
    if (!this.schedule[index].selected && selecteds.length === this.hoursLeft) {
      return;
    }

    if (this.schedule[index].selected) {
      this.schedule[index].selected = !this.schedule[index].selected;
      this.schedule = this.concatenateConsecutiveEvents(this.schedule);
      return;
    }

    let start = DateTime.fromISO(this.schedule[index].start).setZone('UTC');
    let end = DateTime.fromISO(this.schedule[index].end).setZone('UTC');
    let diff = end.diff(start, 'minutes').minutes;
    if (diff > 60) {
      this.showBookingDialog({ start, end, timezone: this.timezone }, index);
    } else {
      this.schedule[index].selected = !this.schedule[index].selected;
      this.schedule = [].concat(this.schedule);
    }
  }

  /**
   * Show Dialog to select start of range to create a class
   * @param data
   * @param index
   */
  showBookingDialog(data: Object, index: any) {
    const bookingDialogRef = this.dialog.open(BookingDialogComponent, {
      data,
      autoFocus: false,
    });

    const subscribed = bookingDialogRef
      .afterClosed()
      .subscribe(async (data) => {
        subscribed.unsubscribe();
        if (!data) {
          return;
        }
        this.configureSchedule(data, index);
      });
  }

  /**
   * Adapt current schedule to be understable for the user
   * @param data
   * @param index
   */
  configureSchedule(data: any, index: any) {
    const schedules = [];
    const selectedStart: DateTime = data.start;
    const selectedEnd: DateTime = data.end;
    let start = DateTime.fromISO(this.schedule[index].start).setZone('UTC');
    let end = DateTime.fromISO(this.schedule[index].end).setZone('UTC');
    let diffStarts = selectedStart.diff(start, 'minutes').minutes;
    let diffEnds = end.diff(selectedEnd, 'minutes').minutes;

    if (diffStarts) {
      schedules.push({
        start: start.toISO(),
        end: selectedStart.toISO(),
        available: diffStarts >= 59,
        selected: false,
        groupId: this.schedule[index].groupId,
      });
    }

    if (diffEnds) {
      schedules.push({
        start: selectedEnd.toISO(),
        end: end.toISO(),
        available: diffEnds >= 59,
        selected: false,
        groupId: this.schedule[index].groupId,
      });
    }

    schedules.push({
      start: selectedStart.toISO(),
      end: selectedEnd.toISO(),
      available: true,
      selected: true,
      groupId: this.schedule[index].groupId,
    });

    this.schedule.splice(index, 1);

    this.schedule = this.schedule.concat(schedules);
  }

  /**
   * Join events which are consecutives and availables
   * @param entry
   * @returns
   */
  concatenateConsecutiveEvents(entry: any) {
    let availableEvents: any = [];
    let otherEvents: any = [];

    entry.forEach((e: any) => {
      if (!e.selected) {
        availableEvents.push(e);
      } else {
        otherEvents.push(e);
      }
    });

    let exit: any = [];

    availableEvents.sort((a: any, b: any) => {
      const startA = DateTime.fromISO(a.start).setZone('UTC');
      const startB = DateTime.fromISO(b.start).setZone('UTC');

      if (startA.toMillis() > startB.toMillis()) {
        return 1;
      }
      return -1;
    });

    for (let index = 0; index < availableEvents.length; index++) {
      if (index === 0) {
        exit.push(availableEvents[index]);
        continue;
      }
      const currentEvent = availableEvents[index];
      const previousEvent = availableEvents[index - 1];

      const currentEventStart = DateTime.fromISO(currentEvent.start).setZone(
        'UTC'
      );
      const previousEventEnd = DateTime.fromISO(previousEvent.end).setZone(
        'UTC'
      );
      if (!currentEventStart.equals(previousEventEnd)) {
        exit.push(currentEvent);
        continue;
      }

      exit[exit.length - 1].end = availableEvents[index].end;

      if (currentEvent.available && !exit[exit.length - 1].available) {
        exit[exit.length - 1].available = true;
      }
    }
    exit = exit.concat(otherEvents);

    return exit;
  }

  validateLessonForm() {
    return (formGroup: FormGroup) => {
      let res = null;

      // return if another validator has already found an error on the matchingControl
      if (formGroup.errors && !formGroup.errors.badOrder) {
        return;
      }

     
    };
  }

  onChangeLessonValue($event: any) {
    this.form.patchValue({
      level: null,
    });
  }




  //¿delete?

  // loadLessonOptions() {
  //   const customLessons: any = [];
  //   this.teacher.custom_lessons_modified.forEach(
  //     (custom_lesson_modified: any, index: any) => {
  //       const custom_lessons_by_keys = this.teacher.custom_lessons.filter(
  //         (e: any) =>
  //           e.name === custom_lesson_modified.name &&
  //           e.lesson_id === custom_lesson_modified.lesson_id
  //       );

  //       customLessons.push({
  //         id: 'custom_lesson_' + index,
  //         name: custom_lesson_modified.name,
  //         type: custom_lesson_modified.type,
  //         levels: custom_lessons_by_keys
  //           .filter((e: any) => e.level_id !== null)
  //           .map((e: any) => {
  //             return {
  //               id: e.level_id,
  //               name: e.level_name,
  //             };
  //           }),
  //       });
  //     }
  //   );

  //   this.lessonOptions = this.teacher.lessons.concat(customLessons);

  //   if (!this.currentSubject?.id) {
  //     return;
  //   }
  //   const currentLesson = this.findCurrentLesson();

  //   if (!currentLesson) {
  //     return;
  //   } else {
  //     this.form.patchValue({
  //       lesson: currentLesson,
  //     });
  //   }
  // }






  //¿delete?
  // findCurrentLesson() {
  //   const currentLesson = this.lessonOptions.find((opt: any) => {
  //     if (this.currentSubject?.is_custom === 'true') {
  //       return this.opt.name == this.currentSubject?.name;
  //     } else {
  //       return this.opt.id == this.currentSubject?.id;
  //     }
  //   });
  //   return currentLesson;
  // }




  async onSendMessage(teacher:any) {
    this.general.onSendMessage(teacher);
  }
}
